import { Box } from "@mui/material";
import React from "react";
import projectPackage from "../../../package.json";
import { style } from "./style";

export const Versioning = () => {
  return <Box sx={style.versioning}>{projectPackage?.version}</Box>;
};
